<template>
  <v-dialog
    v-model="show"
    scrollable
    persistent
    width="600"
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-card-title>
        <strong>แก้ไขรายการ</strong>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 540px">
        <div v-if="items != null">
          <template v-for="(item, index) in items">
            <v-row
              v-if="item.product_id"
              :key="index"
              style="border-bottom: 1px solid #efefef"
            >
              <v-col cols="8">
                {{ item.name }}
              </v-col>
              <v-col class="text-right" cols="4">
                <v-btn
                  outlined
                  small
                  color="primary"
                  ripple
                  @click="remove(item)"
                  >-</v-btn
                >
                <span class="mx-4 font-weight-bold">{{ item.quantity }}</span>
                <v-btn depressed small color="primary" ripple @click="add(item)"
                  >+</v-btn
                >
              </v-col>
            </v-row>
          </template>
        </div>
        <div class="text-center my-8" v-else>ไม่มีข้อมูล</div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="py-3">
        <v-btn depressed block color="primary" ripple @click="save"
          >ยืนยัน</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Service from "../services";
import { monthList } from "../utils/Constants";
import moment from "moment";

export default {
  name: "edit-basket-dialog",
  props: {
    items: { default: null },
    showDialog: { default: false },
  },
  data() {
    return {
      loading: false,
      isPass: false,
      isError: false,
      list: [],
    };
  },
  computed: {
    show: {
      get() {
        /*
        if (this.showDialog) {

        }
        */
        return this.showDialog;
      },
      set(value) {
        // If close dialog.
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    remove(item) {
      let index = this.items.findIndex((x) => x.product_id == item.product_id);
      if (this.items[index].quantity > 0) {
        this.items[index].quantity--;
      }
    },
    add(item) {
      let index = this.items.findIndex((x) => x.product_id == item.product_id);
      this.items[index].quantity++;
    },
    save() {
      this.$emit("save", this.items);
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
